module.exports = __webpack_public_path__ + "media/beijing.a6dc7770.mp3";